var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 207,
    viewBox: "0 0 130 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.295 0C104.165 40.6603 133.55 98.991 115.9 118.593C98.25 138.195 59.9731 64.0973 75.4387 53.5793C90.9044 43.0613 123.401 118.275 95.7591 138.742C68.117 159.208 17.5905 96.5243 34.7442 82.8926C51.8978 69.261 96.9353 127.906 72.2082 161.329C47.4811 194.753 2.24908 202.337 2.24908 202.337",
    stroke: "url(#paint0_linear_36_378)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4439 193.1C13.4439 193.1 6.74633 200.01 1.00001 202.792C8.4252 202.792 15.9926 205.829 15.9926 205.829",
    stroke: "url(#paint1_linear_36_378)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_378",
    x1: -7.56286,
    y1: -79.3477,
    x2: 280.931,
    y2: -60.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48E3F",
    stopOpacity: 0.54
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_378",
    x1: 3.32837,
    y1: 186.111,
    x2: 36.1207,
    y2: 197.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48E3F",
    stopOpacity: 0.54
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.ab9d4ebbe78ce2c9ac8717233da87239.svg";
export { ForwardRef as ReactComponent };